<template>
  <div class="overlay">
    <div class="overlay-content">
      <a href="#" @click="back" class="overlay-close">✕</a>
      <div class="overlay-inner">
        <h2>Contact</h2>

        <p>Have we awoken your interest? If so, then please feel free to get in touch with us to work on a <span class="versa">GREEN</span>
          future.</p>
        <p> Dipl. Wi.-Ing. Christian Huder</p>

        <p>hello@innergy.berlin</p>

        <h2 class="after">About</h2>

        <p><span class="versa">BERLIN</span> offers a very <span class="versa">UNIQUE ECOSYSTEM</span> to support and encourage <span class="versa">ENTREPRENEURSHIP</span>. There is hardly any other
          city in the world, that provides such a matchless ecosystem: political stability, access to finance, strong
          national markets and a city which is still under development after its reunification in 1989, providing lots
          of affordable, open spaces in the city centre for new ideas and creative people. This especially attracts
          <span class="versa">DIVERSE PEOPLE</span> from all over the world, who dive into the urban space to explore alternative ways of living
          apart from the standard capitalism which obviously does not do a good job in protecting our planet. This
          ecosystem is supported and amplified by an extremely wide range of cultural activities. At the same time
          there are very good social security instruments in place and only few governmental limitations hinder the
          evolution of individuals.</p>

        <p>This way of living has also produced a broad consent, that <span class="versa">ECONOMIES</span> must operate <span class="versa">SUSTAINABLY</span> and need to
          protect our environment and climate in order to ensure a positive growth of society in the future.</p>

        <p>Combining this, with Germany`s leading position in building and operating renewable energies, Berlin is
          clearly a singular place for <span class="versa">CLEANTECH INNOVATION</span> and entrepreneurship. Current investment rates into Berlin
          start-ups back this observation: in the first half of 2015 it surpassed already €1.5 bn and thereby achieved
          the highest investment rate in Europe<span class="reference">1</span>. But this does not make other
          innovation centres around the world less attractive, which is why we cultivated a strong <span class="versa">NETWORK</span> across
          Europe and to the Silicon Valley.</p>

        <p class="footnote">(1) <a
          href="//www.ey.com/DE/de/Newsroom/News-releases/EY-20150827-Berlin-ist-Europas-Start-up-Hauptstadt" target="_blank">Ey –
          Start-up-Barometer Deutschland</a>
        </p>
      </div>
    </div>
  </div>
</template>
<style>
</style>
  <script>
    export default {
      methods: {
        back () {
          window.history.go(-1)
        }},
      data: function () {
        return {
          title: 'Contact | About'
        }
      },
      // Usage with context the component
      head: {
        // To use "this" in the component, it is necessary to return the object through a function
        title: function () {
          return {
            inner: this.title
          }
        },
        meta: [
          { name: 'description', content: 'My description', id: 'desc' }
        ]
      }
    }
</script>



// WEBPACK FOOTER //
// About.vue?257294f4